import React from 'react';
import Link from 'next/link';
import { Grid, Typography, Button, Box } from '@mui/material';
import Image from 'next/image';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScrollAnimation from './ScrollAnimation';

const ContentHighlights = ({ title, highlights, buttonText, imageSrc, imageAlt, imageFirst }) => {
    const renderHighlights = highlights.map((highlight, index) => (
        <Box key={index} sx={{ mb: 3, mt: 3 }}>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, fontSize: '20px', color: '#FFF' }}>
                <CheckCircleIcon sx={{ color: '#8BC34A', fontSize: '20px', marginRight: '10px' }} />
                {highlight.title}
            </Typography>
            <Typography variant="body1" sx={{ color: 'white', fontSize: '16px', lineHeight: '160%', textAlign: 'left' }}>
                {highlight.description}
            </Typography>
        </Box>
    ));

    const textSection = (
        <Grid item xs={12} md={6} sx={{ textAlign: 'left', px: 5 }}>
            <Box sx={{ pl: imageFirst ? '80px' : '0px', mt: 2 }}>
                <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Typography variant="h3" gutterBottom sx={{
                        color: 'white',
                        fontWeight: 700,
                        mt: '30px',
                        mb: 3,
                        fontSize: '34px',
                        lineHeight: '120%',
                        textAlign: 'left',
                    }}>
                        {title}
                    </Typography>
                    <Box sx={{
                        position: 'absolute',
                        bottom: 0, // Adjust the value as needed
                        left: 0,
                        right: 0,
                        zIndex: 0,
                        marginBottom: '5px',
                        rotate: '180deg',
                        height: '1.10rem',
                        backgroundImage: 'url(/dual-underline.svg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }} />
                </Box>

                {renderHighlights}


                <Link href="/app/login" underline="none" hover="none">
                    <Button variant="outlined" sx={{
                        color: '#f06f96',
                        fontSize: '18px',
                        border: 'solid 2px #f06f96',
                        fontWeight: 400,
                        ineHeight: '160%',
                        textAlign: 'left',
                        textTransform: 'none',
                        mt: 4,
                        '&:hover': { background: '#f06f96', color: 'white', border: 'solid 2px #f06f96' }
                    }}>
                        {buttonText}
                        <ArrowForwardIcon sx={{ ml: 1 }} />
                    </Button>
                </Link>

            </Box>
        </Grid >
    );

    const imageSection = (
        <Grid item xs={12} md={6}>
            <Box sx={{
                textAlign: imageFirst ? 'left' : 'right',
                pl: imageFirst ? '0' : '60px',
                pr: imageFirst ? '60px !important' : '0',
            }}>
                <Image
                    src={imageSrc}
                    alt={imageAlt}
                    width={571}
                    height={462}
                    style={{
                        borderRadius: '10px',
                        boxShadow: 'rgb(255 35 171) 0px 0px 10px 2px',
                        width: '100%', // Ensures responsiveness
                        height: 'auto',
                      }}
                />
            </Box>
        </Grid>
    );

    return (
        <ScrollAnimation animateIn="fadeInUp" delay={0.2}>
            <Grid container spacing={2} sx={{ mt: 5, alignItems: 'center' }}>
                {imageFirst ? imageSection : textSection}
                {imageFirst ? textSection : imageSection}
            </Grid>
        </ScrollAnimation>
    );
};

export default ContentHighlights;
